import {
	WhiteButton,
	YellowButton,
} from "../../../components/UI/Button/button";
import { LocationIcon } from "../../../constants/svg";
import classes from "./JobDetails.module.css";
import Twitter from "../../../assets/images/JobsDetails/twitter.svg";
import Instagram from "../../../assets/images/JobsDetails/instagram.svg";
import Facebook from "../../../assets/images/JobsDetails/facebook.svg";
import Website from "../../../assets/images/JobsDetails/website.svg";
import Share from "../../../assets/images/JobsDetails/share.svg";
import { StanThumbUp } from "../../../constants/stan";
import { useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import { errorHandler, toastSuccess } from "../../../utils";
import { getJobByID, talentApplyJob, talentJobInteraction, talentProfile } from "../../../services/talentCalls";
import moment from "moment";
import Loop from "../../../assets/loader/loop.svg";
import { Link } from "react-router-dom";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import confusedStan from "../../../assets/illustrations/confused-stan-blue.png";
import confusedStanYellow from "../../../assets/illustrations/no-sub-stan.png";
import { UserContext } from "../../../context";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";
import { currencyFormat } from "../../../utils/functions";
import Whatsapp from "../../../assets//svgs/whatsapp.svg";

const Popup = ({ showModal }) => {
	return (
		<div className={classes.bg}>
			<div className={`${classes.modal}`}>
				<div className="flex relative center">
					<span className="center-flex" onClick={() => showModal(false)}>
						x
					</span>
					<StanThumbUp shirtColor={`#030659`} />
					<h3 className={classes.modalHeader}>Great Stuff!</h3>
					<p className="mt-sm mb-md">You have successfully applied.</p>
					<p>Goodluck</p>
				</div>
			</div>
		</div>
	);
};

const JobDetails = () => {
	let navigate = useNavigate();
	const [modal, showModal] = useState(false);
	const [load, setLoad] = useState(false);
	const [loading, setLoading] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [jobsArr, setJobsArr] = useState([]);
	const [takeTestModal, setTakeTestModal] = useState(false);
	const [hasTakenTest, setHasTakenTest] = useState(true);
	const { id } = useParams();
  	const { data, setData } = useContext(UserContext);
	
	const jobUrl = `${window.location.origin}/job/${id}`;

	const shareToTwitter = () => {
		const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(jobUrl)}&text=${encodeURIComponent(`Check out this job: ${jobsArr?.title}`)}`;
		window.open(twitterUrl, "_blank");
	};

	const shareToFacebook = () => {
		const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(jobUrl)}`;
		window.open(facebookUrl, "_blank");
	};

	const shareToInstagram = () => {
		errorHandler("Instagram sharing is not supported via web. Please copy the link and share it on Instagram.", "info");
	};

	const copyToClipboard = async () => {
		try {
			await navigator.clipboard.writeText(jobUrl);
			toastSuccess("Job link copied to clipboard!");
		} catch {
			errorHandler("Failed to copy link", "error");
		}
	};

	const shareToWhatsApp = () => {
		errorHandler(
			"Opening WhatsApp to share job link.",
			"info"
		);
		const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
			`Check out this job: ${jobUrl}`
		)}`;
		window.open(whatsappUrl, "_blank");
	};

	const handleApplication = async (e) => {
		e.preventDefault();
		if (jobsArr?.applicantTalentIds?.includes(data?._id)) {
			errorHandler("You have already applied for this job", "Error");
			return;
		}
		if (!hasTakenTest) {
			setTakeTestModal(true);
			return;
		}
		// Block only when the profile is loaded and genuinely unverified. If it has not
		// loaded yet, let the request through and rely on the API's verification check,
		// rather than telling a verified talent they are unverified.
		if (!data || data.profileVerified) {
			try {
				setLoad(true);
				const res = await talentApplyJob(id);
				if (res?.data.success) {
					await talentJobInteraction({
						jobId: id,
						interactionType: "apply",
					})
					setLoad(false);
					showModal(true);
					getJob()
				}
			} catch (error) {
				setLoad(false);
				error?.response.data
					? errorHandler(error.response.data.errors, "Error")
					: errorHandler("Network error: Please check your internet connection and try again.", "Error");
			}
		} else {
			setIsModalOpen(true);
		}
	};

	const goToSupport = () => {
		navigate("/talent-support");
		setIsModalOpen(false);
	};

	const getJob = async () => {
		try {
			setLoading(true)
			const res = await getJobByID(id);
			if(res?.data.data.job) {
				setJobsArr(res.data.data.job);
				setLoading(false)
			}
		} catch (error) {
			setLoading(false)
			error.response?.data ? 
			errorHandler(error.response.data.errors, "Error") : 
			errorHandler("Network error: Something went wrong, Please check your internet connection and try again.", "Error");	
		} finally {
			setLoading(false)
		}
	};

	const getUserProfile = async () => {
		try {
			const res = await talentProfile();
			if (res?.data.data.talent) {
				setData(res.data.data.talent);
			}
			setLoad(false);
		} catch (error) {
			setLoad(false);
		}
	};

	useEffect(() => {
		getJob();
		getUserProfile();
	}, []);

	useEffect(() => {
		if (data?.submittedPsychometricTest === false) {
			setHasTakenTest(false)
		}
	}, [data]);

	return (
		<>
			{loading && <FullScreenLoader /> }
			{modal && <Popup showModal={showModal} />}
			<div className={classes.parent}>
				<div className={`flex ${classes.between} ${classes.info} ${classes.column}`}>
					<div className={`flex ${classes.info} ${classes.column}`}>
						<div className={`center-flex ${classes.picture}`}>
							<span>A</span>
						</div>
						<div>
							<h3>{jobsArr?.title}</h3>
							<p className="mt-sm mb-sm">{jobsArr?.description}</p>
							<p className={`flex ${classes.info}`}>
								<LocationIcon /> 
								{" "}{jobsArr?.location}
							</p>
						</div>
					</div>
					<div className={`mt-sm ${classes.socialsinfo}`}>
						<Link className={classes.rightLink} to={`/view-company/${jobsArr?.clientId}`}>View company profile </Link>
						<div className={`flex mt-sm ${classes.links} ${classes.allSocialsinfo}`}>
							<img src={Share} alt="Share" onClick={copyToClipboard} style={{ cursor: 'pointer' }} />
							<img src={Instagram} alt="Instagram" onClick={copyToClipboard} style={{ cursor: 'pointer' }} />
							<img src={Twitter} alt="Twitter" onClick={shareToTwitter} style={{ cursor: 'pointer' }} />
							<img src={Facebook} alt="Facebook" onClick={shareToFacebook} style={{ cursor: 'pointer' }} />
							<img src={Whatsapp} alt="Whatsapp" onClick={shareToWhatsApp} style={{ cursor: 'pointer' }} />
							{/* <a href="https://www.example.com" target="_blank" rel="noreferrer">
								<img src={Website} alt="Website" />
							</a> */}
						</div>
					</div>
				</div>
				<div className={`mt-md mb-md ${classes.hrRule}`} />
				<div className={classes.gap}>
					<div className={`flex ${classes.between} ${classes.column}`}>
						<div>
							<h3 className="capitalise">{jobsArr?.title} {jobsArr?.provideOneMonthNotice === "Yes" ? "(1yr guarantee)" : ""}</h3>
							<p className={classes.subtxt}>
								({jobsArr?.duration}) {moment(jobsArr?.startDate).format("MMM yyyy")} - {moment(jobsArr?.endDate).format("MMM YYYY")}
							</p>
							<p className={classes.subtxt}>
								{jobsArr?.workMode} {" | "}
								{jobsArr?.location}
							</p>
						</div>
						<h3 className={classes.right}>&#8358;{currencyFormat(Number(jobsArr?.budget ?? 0))} pm</h3>						
					</div>

					<div className={`flex mt-sm ${classes.between} ${classes.column}`}>
						<div className={`flow ${classes.objective}`}>
							<h4> Description </h4>
							<p>{jobsArr?.description}</p>
						</div>
					</div>

					<div className={`flex mt-sm ${classes.between} ${classes.column}`}>
						<div className={`flow ${classes.objective}`}>
							<h4>Acceptance Criteria</h4>
							<p>{jobsArr?.acceptanceCriteria}</p>
						</div>
					</div>

					<div className={`flex mt-sm ${classes.between} ${classes.column}`}>
						<div className={`flex ${classes.skillObjective} ${classes.skillObjectiveFlex}`}>
							<h4>Skill</h4>{" "}
							{jobsArr?.skillsAndRequirements?.map((item, idx) => (
								<p key={idx}>{item}</p>
							))}
						</div>
					</div>

					<div className={`flex mt-sm ${classes.between} ${classes.column}`}>
						<div className={`flow ${classes.objective}`}>
							<h4>Objectives</h4>
							<p>{jobsArr?.objectives}</p>
						</div>
					</div>
				</div>
				<div className={`flex mt-md ${classes.btn}`}>
					<WhiteButton onClick={() => navigate(-1)}>Cancel</WhiteButton>
					{load ? (
						<img src={Loop} alt="loader" className={classes.loader} />
					) : (
						<>
							{jobsArr?.applicantTalentIds?.includes(data?._id) ? (
								<span className={classes.appliedTxt}>Applied</span>
							) : (
								<YellowButton disabled={load} onClick={handleApplication}>
									Apply Now
								</YellowButton>
							)}
						</>
					)}
				</div>
			</div>

			<ErrorModal isModalOpen={isModalOpen} setModalOpen={setIsModalOpen} hasCloseIcon>
				<div className={classes.modalContent}>
					<img className={classes.modalImage} src={confusedStan} alt="" />
					<p>
						Your profile hasn't been verified yet. Once your account is
						verified, you'll be able to apply for jobs.
					</p>
					<button onClick={goToSupport} className={classes.modalButton}>
						Contact Support
					</button>
				</div>
			</ErrorModal>
			<ErrorModal
				isModalOpen={takeTestModal}
				setModalOpen={setTakeTestModal}
				hasCloseIcon={true}
				navigate={() => navigate("/test")}
			>
				<div className={classes.modalContent}>
					<img className={classes.modalImage} src={confusedStanYellow} alt="" />
					<h6 className="text-white text-2xl">
						Complete your psychometric test
					</h6>
					<p className="font-light">
						You need to do it so the client can <br /> understand you better.
					</p>
					<button
						onClick={() => {
						navigate("/test");
						setTakeTestModal(false);
						}}
						className={classes.modalButton}
					>
						Take your Test
					</button>
				</div>
      		</ErrorModal>

		</>
	);
};

export default JobDetails;